export default class Translations {
  constructor(api) {
    this.api = api;
  }

  fetchTranslation = (locale) => this.api.fetchTranslation(locale);
}
